import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, useMediaQuery, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useRTL from 'src/hooks/useRTL';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import { PlayArrowOutlined } from '@mui/icons-material';
import { theme } from '../../../Template3/Template';
import { useCompanyData } from '../../contexts/DataContext';
import { useNavigate } from 'react-router-dom';
import GetImageDimensions from '../../logic/getImgDimensions';
import { PhotoPreview } from 'src/components/white-label-component/company-comp';
import { createMarkup } from '../../logic/Utils';
import { SectionTitle, SectionSubtitle, SectionParagraph } from "../../../Template3/components/SectionTitle";
// import { SectionTitle as T1SectionTitle, SectionSubtitle as T1SectionSubTitle, SectionParagraph as T1SectionParagraph } from '../../../Template1/components/SectionTitle';
// import { SectionTitle as T2SectionTitle, SectionSubtitle as T2SectionSubTitle, SectionParagraph as T2SectionParagraph } from '../../../Template2/components/SectionTitle';
// import { SectionTitle as T3SectionTitle, SectionSubtitle as T3SectionSubTitle, SectionParagraph as T3SectionParagraph } from '../../../Template3/components/SectionTitle';
// import { SectionTitle as T4SectionTitle, SectionSubtitle as T4SectionSubTitle, SectionParagraph as T4SectionParagraph } from '../../../Template4/components/SectionTitle';
import PlayButtonIcon from 'src/assets/images/company booking/playbutton.svg';
import SectionLayout from '../../layout/SectionLayout';
import DemoImg from 'src/assets/images/website-sections/content3Img.png';
import { textVariant, textClasses } from '../../config';
import { staticText } from './config';
import '../../../shared/styles.css'

const useStyles = makeStyles((theme) => ({
    aboutImg:props => ({
        '& img':{
            '@media (max-width:720px)':{
                boxShadow: props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
                "-webkit-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
                "-moz-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
            }
        },

        boxShadow: props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
        "-webkit-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
        "-moz-box-shadow": props.imageShadow ? (props?.imageShadowContent ? props?.imageShadowContent : props?.itemShadow || '0px 0px 30px rgb(209,209,209)') : 'none',
        '@media (max-width:720px)':{
            boxShadow: 'none',
            "-webkit-box-shadow":  'none',
            "-moz-box-shadow": 'none',
        }
    }),

    tp:{
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        fontFamily:"'Cairo', sans-serif"
    },

    playBtn:{
        position: 'absolute',
        margin: 'auto',
        width: '100%',
        height: '100%',
        cursor:'pointer',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
    },

    playBtnWrapper:{
        width:'97px',
        height:'97px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    }
}));

// const TitleList = {
//     '1': T1SectionTitle,
//     '2': T2SectionTitle,
//     '3': T3SectionTitle,
//     '4': T4SectionTitle,
// };

// const SubTitleList = {
//     '1': T1SectionSubTitle,
//     '2': T2SectionSubTitle,
//     '3': T3SectionSubTitle,
//     '4': T4SectionSubTitle,
// };

// const ParagraphTitleList = {
//     '1': T1SectionParagraph,
//     '2': T2SectionParagraph,
//     '3': T3SectionParagraph,
//     '4': T4SectionParagraph
// };

const fontFamilyList = {
    '1': "'Nunito Sans', sans-serif",
    '2': "'Roboto', sans-serif",
    '3': "'Poppins', sans-serif",
    '4': "'Nunito Sans', sans-serif",
};

const Content3 = (props) => {
    const [imageDimensions, setImageDimensions] = React.useState({});
    const [previewDialog, setPreviewDialog] = React.useState(false);
    const { data } = useCompanyData();
    const { companyDomain, isRTL, companyData, themeDesign } = data;
    const { pathname:url } = useLocation();
    const { contentData, index } = props;
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);

    const matches720 = useMediaQuery('(min-width:720px)');
    const matches = useMediaQuery(theme.breakpoints.up('lg'));
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const { buttonColor, buttonFontColor, buttonFontSize, autoButtonSize, buttonWidth, buttonHeight, sectionBackgroundColor, sectionPaddingTop, sectionPaddingBottom, sectionPaddingLeft, sectionPaddingRight,
        itemShadow, imgRadiusGeneral,buttonRadiusGeneral,
        // sectionFontColor,
        generalTitleFontSize, generalSubTitleFontSize, generalParagraphFontSize,
        generalTitleColor, generalSubTitleColor, generalParagraphColor,
        chatgptContent
    } = data || {};
    const { imageShadow=true, spaceBetweenContent, textBackground, textBorder, textRadius, imageAlt, imageShadowContent, imageRadius, imageBorder, direction, buttonBorder } = contentData || {};
    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : '#007AFF';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : '#FFFFFF';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize ? buttonFontSize : '18';
    const _buttonWidth = contentData?.autoButtonSize || autoButtonSize ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` :
    '200px';
    const _buttonHeight = contentData?.autoButtonSize || autoButtonSize ? 'unset' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` :
    '50px';
    const classes = useStyles({itemShadow,imageShadow,imageShadowContent,direction});
    
    React.useEffect(() => {
        GetImageDimensions(setImageDimensions, contentData?.image);
    }, [contentData?.image]);

    const buttonEvent = () => {
        if(contentData?.path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${contentData?.path}` : `${_path}/temp/${contentData?.path}`)
        }
        else{
            window.open(contentData?.externalLink,'_blank')
        }
    };

    const closeDialog = () => {
        setPreviewDialog(false);
    }

    const chatgptTitle = chatgptContent ? (isRTL === 'ar' ? chatgptContent?.['arabic']?.[`section${index}`]?.['title'] : chatgptContent?.['english']?.[`section${index}`]?.['title']) : '';
    const chatgptSubTitle = chatgptContent ? (isRTL === 'ar' ? chatgptContent?.['arabic']?.[`section${index}`]?.['subtitle'] : chatgptContent?.['english']?.[`section${index}`]?.['subtitle']) : '';
    const chatgptDesc = chatgptContent ? (isRTL === 'ar' ? chatgptContent?.['arabic']?.[`section${index}`]?.['description'] : chatgptContent?.['english']?.[`section${index}`]?.['description']) : '';

    const title = chatgptTitle ? chatgptTitle : isRTL === 'ar' && contentData?.arTitle ? contentData?.arTitle?.trim() : contentData?.title?.trim() || staticText.title;
    const subTitle = chatgptSubTitle ? chatgptSubTitle : isRTL === 'ar' && contentData?.arSubTitle ? contentData?.arSubTitle?.trim() : contentData?.subTitle?.trim() || staticText.subTitle;
    const description = chatgptDesc ? chatgptDesc : isRTL === 'ar' && contentData?.arDescription ? contentData?.arDescription : contentData?.description || staticText?.description;
    const buttonTitle = isRTL === 'ar' && contentData?.arButtonTitle ? contentData?.arButtonTitle : contentData?.buttonTitle || staticText?.buttonTitle;

    const textAlign = !mobileView ? contentData?.direction === 'left' && isRTL === 'en' ? 'left' : 
                        contentData?.direction === 'left' && isRTL === 'ar' ? 'right' :
                        contentData?.direction === 'right' && isRTL === 'en' ? 'left' :
                        contentData?.direction === 'right' && isRTL === 'ar' ? 'right' : 'center' : 'center';
    
    const pTop = contentData?.paddingTop ? contentData?.paddingTop : sectionPaddingTop ? sectionPaddingTop : null;
    const pBottom = contentData?.paddingBottom ? contentData?.paddingBottom : sectionPaddingBottom ? sectionPaddingBottom : null;

    const imgRadius = imageRadius ? `${imageRadius}px` : '10px'; 
    const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : '5px'; 

    const spaceBtwMargin = contentData?.direction === 'left' ? `0px ${spaceBetweenContent}px 0px 30px` :
    contentData?.direction === 'right' ? `0px 30px 0px ${spaceBetweenContent}px` : '0px 30px';

    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : generalTitleFontSize ? generalTitleFontSize : null;
    const subTitleFontSize = contentData?.subTitleFontSize ? contentData?.subTitleFontSize : generalSubTitleFontSize ? generalSubTitleFontSize : null;
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : 18;

    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '#000';
    const subTitleFontColor = contentData?.subTitleFontColor ? contentData?.subTitleFontColor : '#36ABEF';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '#6B7385';

    // const TitleComponent = TitleList?.[themeDesign];
    // const SubTitleComponent = SubTitleList?.[themeDesign];
    // const ParagraphTitleComponent = ParagraphTitleList?.[themeDesign];
    return (
        (<Box
            width="100%"
            dir="ltr"
            style={contentData?.width === 'fullWidth' ?
            {backgroundImage: contentData?.backgroundStyle === 'image' && contentData?.backgroundImage ? 
            `url(${contentData?.backgroundImage})` :
            contentData?.backgroundStyle === 'gradient' && contentData?.backgroundColor ? contentData?.backgroundColor || 'transparent' : 'transparent',
            backgroundRepeat: contentData?.backgroundStyle === 'image' && contentData?.backgroundImage ? "no-repeat" : "",

            ...((contentData?.backgroundStyle === 'image' && contentData?.backgroundImage) ? {backgroundSize: "cover"} : {}),
            ...((contentData?.backgroundStyle === 'solidColor' && contentData?.backgroundColor) ? {backgroundColor: contentData?.backgroundColor || 'transparent'} : {backgroundColor: contentData?.backgroundColor || 'transparent'})
            }
            : {}
            }
        >
            <SectionLayout
                paddingLeft={sectionPaddingLeft}
                paddingRight={sectionPaddingRight}
                paddingTop={pTop}
                paddingBottom={pBottom}
            >
            <Box
                display="flex"
                flexDirection={matches720 ? contentData?.direction === 'left' ? 'row' : contentData?.direction === 'right' ? 'row-reverse' : 'column' : 'column'}
                alignItems={matches720 ? contentData?.direction === 'center' ? 'center' : contentData?.alignment ? contentData?.alignment : 'center' : 'center'}
                justifyContent={!matches720 ? "center" : contentData?.direction === 'center' ? 'unset' :  'space-between'}
                width={"100%"}
                // borderRadius= "undefinedpx"
                m="auto"
                position="relative"
                height={contentData?.height ? `${contentData?.height}px` : 'auto'}

                style={contentData?.width === 'boxed' ?
                {backgroundImage: contentData?.backgroundStyle === 'image' && contentData?.backgroundImage ? 
                `url(${contentData?.backgroundImage})` :
                contentData?.backgroundStyle === 'gradient' && contentData?.backgroundColor ? contentData?.backgroundColor || sectionBackgroundColor || '#ffffff' : '#ffffff',
                backgroundRepeat: contentData?.backgroundStyle === 'image' && contentData?.backgroundImage ? "no-repeat" : "",
    
                ...((contentData?.backgroundStyle === 'image' && contentData?.backgroundImage) ? {backgroundSize: "cover"} : {}),
                ...((contentData?.backgroundStyle === 'solidColor' && contentData?.backgroundColor) ? {backgroundColor: contentData?.backgroundColor || sectionBackgroundColor || '#ffffff'} : {backgroundColor: contentData?.backgroundColor || sectionBackgroundColor || '#ffffff'})
                }
                : {}
                }
            >

                <Box
                mb={matches ? 0 : 4}
                width={matches720 ? contentData?.direction === 'center' ? 'calc(100% - 10px)' : 'calc(50% - 10px)' : 'calc(100% - 10px)'}
                p="5px"
                // minWidth="300px"
                style={{...(textBorder ? {border: textBorder} : {}),...(textBackground ? {background: textBackground} : {}),...(textRadius ? {borderRadius: `${textRadius}px`} : {})}}
                // style={mobileView ? {} : {margin: spaceBetweenContent ? spaceBtwMargin : '0px 30px'}}
                >

                      {subTitle ?
                    <Box display={matches ? 'block' : 'flex'} flexDirection="column" alignItems="center">
                        <SectionSubtitle {...(subTitleFontColor ? {color: subTitleFontColor} : {} )} pb="13px" pFontSize={subTitleFontSize} wordBreak="break-word" visibleHorizontalLine={false} textAlign={textAlign} display="block" style={themeDesign === 3 && isRTL === 'ar' ? {flexDirection: 'row-reverse'} : {}}>{subTitle}</SectionSubtitle>
                    </Box>
                    : null}

                    {title ?
                    <Box
                        display={matches ? 'block' : 'flex'}
                        flexDirection="column"
                        alignItems="center"
                    >
                        <SectionTitle {...(titleFontColor ? {color: titleFontColor} : {} )} pb="22px" pFontSize={titleFontSize} wordBreak="break-word" textAlign={textAlign} {...([1,4]?.includes(themeDesign) ? {contentSection: true } : {} )}>{title}</SectionTitle>
                    </Box>
                    : null}

                  

                    <Box pb={'22px'} dir={isRTL === 'ar' ? 'rtl' : 'ltr'} textAlign={matches ? contentData?.direction ? textAlign : '' : 'center'}>
                        <SectionParagraph
                            {...(descFontColor ? {color: descFontColor} : {} )}
                            pFontSize={descriptionFontSize}
                            description={createMarkup(description)}
                        />
                    </Box>

                    {contentData?.button ?
                        <Box textAlign={matches ? contentData?.direction ? textAlign : '' : 'center'}>
                            <CustomButton
                            style={{
                                backgroundColor: _buttonColor,
                                textTransform:'capitalize',
                                color: _buttonFontColor,
                                width: _buttonWidth,
                                height: _buttonHeight,
                                borderRadius: btnRadius,
                                fontFamily: 'inherit',
                                ...(buttonBorder ? {border:buttonBorder} : {})
                            }}
                            onClick={buttonEvent}
                            className={textClasses?.[_buttonFontSize]}
                            >
                            {buttonTitle}
                            </CustomButton>
                        </Box>
                    : null
                    }
                </Box>
                {/* image */}
                <Box 
                    width={matches720 ? contentData?.direction === 'center' ? contentData?.imageWidth ? 'auto' : '50%' : contentData?.imageWidth ? 'auto' : '41%' : '100%'}
                >
                <Box
                {...(matches720 ? {overflow:'hidden'}: {})}
                borderRadius={imgRadius}
                className={classes.aboutImg}
                mt={matches ? contentData?.direction === 'center' ? '10px' : '0px' : '10px'}
                // visibility={contentData?.image ? 'visible': 'hidden'}
                position={contentData?.videoUrl && contentData?.addVideo ? "relative" : 'unset'}
                style={{
                    ...(imageBorder && (matches720) ? {border: imageBorder} : {}),
                    ...(contentData?.imageWidth && matches720 ? {width: `${contentData?.imageWidth}px`} : {width:'100%'}),
                    ...(contentData?.imageWidth && matches720 ? {maxWidth: `${contentData?.imageWidth}px`} : {maxWidth:'100%'}),
                    ...(contentData?.imageSize ? {height: `${contentData?.imageSize}px`} : {height:'auto'}),
                    ...(contentData?.imageSize ? {maxHeight: `${contentData?.imageSize}px`} : {})
                }}
                >
                    {contentData?.videoUrl && contentData?.addVideo ? 
                        <div className={classes.playBtn} onClick={()=> contentData?.videoUrl ? setPreviewDialog(true) : null }>
                            <div className={classes.playBtnWrapper}>
                                <img src={PlayButtonIcon} alt='play' />
                            </div>
                        </div>
                    : null }
                <ImgLazyLoad>
                    <img
                    style={{
                        ...(!matches720 ? {width:"100%"} : {}),
                        width: "100%",
                        height:"auto",
                        borderRadius: imgRadius,
                        ...(imageBorder && !matches720 ? {border: imageBorder} : {}),

                        ...(imageDimensions?.height > 1280 ? {objectFit:'cover'} : {})
                    }}
                    src={contentData?.image || DemoImg}
                    alt={imageAlt ? imageAlt : contentData?.title || 'content'}
                    />
                </ImgLazyLoad>
                </Box>
                </Box>

                {previewDialog && <PhotoPreview dataArray={[{path:contentData?.videoUrl,type:'video'}]} closeEvent={closeDialog} />}
            </Box>
            </SectionLayout>
        </Box>)
    );
};

const CustomButton = ({ children, ...props }) => {
    return (
      <Button size="large" variant="contained" color="primary" {...props}>
        {children}
      </Button>
    );
};

export default Content3;